export default __webpack_public_path__ + "static/media/help-wheel.9b999f94.svg";